webpackJsonp([1],{

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bronze.c8cd691.png";

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/challenger.6e47f6f.png";

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(344)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(407),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(337)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(398),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_LandingPage__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_LandingPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_LandingPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Summoner__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Summoner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Summoner__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',

  routes: [{
    path: '/',
    name: 'LandingPage',
    component: __WEBPACK_IMPORTED_MODULE_2__views_LandingPage___default.a
  }, {
    path: '/:region/:name',
    name: 'Summoner',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Summoner___default.a,
    meta: {
      queue: 'solo'
    }
  }, {
    path: '/:region/:name/flex',
    name: 'SummonerFlex',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Summoner___default.a,
    meta: {
      queue: 'flex'
    }
  }]
}));

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(399),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_analytics__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_analytics___default.a, {
  id: 'UA-102752070-1',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    exception: true
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

var burgers = document.querySelectorAll('.navbar-burger');

for (var i = 0; i < burgers.length; ++i) {
  burgers[i].addEventListener('click', function (event) {
    var target = event.target.dataset.target;
    var $target = document.getElementById(target);
    event.target.classList.toggle('is-active');
    $target.classList.toggle('is-active');
  });
}

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_PopperMixin__ = __webpack_require__(195);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__utils_PopperMixin__["a" /* default */]],
  props: {
    title: {
      type: String,
      default: ''
    },
    trigger: {
      type: String,
      default: 'click'
    },
    width: {
      type: Number
    },
    placement: {
      type: String,
      default: 'bottom'
    }
  },

  methods: {
    // add delay
    hidePopper: function hidePopper() {
      var _this = this;

      if (this.trigger !== 'hover') this.isShow = false;
      this.timer = setTimeout(function () {
        _this.isShow = false;
        _this.popperTimer = setTimeout(function () {
          _this.popper.destroy(); // destroy popper when hide
          _this.popper = null;
        }, 300);
      }, 300);
    }
  },

  computed: {
    popperStyle: function popperStyle() {
      if (this.width && this.width !== 276) {
        return { width: this.width + 'px', maxWidth: 'none' };
      }
      return null;
    }
  }
});

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    icon: String,
    to: {
      default: '/'
    },
    isActive: {
      type: Boolean,
      default: false
    },
    click: {
      type: Function
    },
    router: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      hasChildren: false,
      isOpen: false,
      arrowClass: 'fa-caret-down',
      type: this.$parent.type
    };
  },

  //
  //  computed: {
  //    isOpen() {
  //      return this.isActive;
  //    },
  //  },

  methods: {
    toggle: function toggle() {
      this.isOpen = !this.isOpen;
    },
    getChildrenStatus: function getChildrenStatus() {
      var _this = this;

      this.$children.every(function (item) {
        if (item.isOpen) _this.isOpen = true;
        if (item.type === 'float') _this.arrowClass = 'fa-caret-right';
        return true;
      });
    }
  },

  mounted: function mounted() {
    this.isOpen = this.isActive;
    this.hasChildren = !!this.$slots.sub;
    if (this.hasChildren) {
      this.getChildrenStatus();
      if (this.arrowClass === 'fa-caret-right') {
        this.$el.addEventListener('mouseenter', this.toggle);
        this.$el.addEventListener('mouseleave', this.toggle);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$el.removeEventListener('mouseenter', this.toggle);
    this.$el.removeEventListener('mouseleave', this.toggle);
  }
});

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    label: String,
    type: {
      type: String,
      default: 'collapse'
    }
  },

  data: function data() {
    return {
      typeClass: this.type,
      isOpen: false
    };
  },


  methods: {
    hasOpened: function hasOpened() {
      var _this = this;

      this.$children.every(function (item) {
        if (item.isOpen) _this.isOpen = true;
        return true;
      });
      return false;
    }
  },

  mounted: function mounted() {
    this.hasOpened();
  }
});

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(38);

//
//
//
//
//
//
//
//
//
//
//





// enumerating ECharts events for now
var ACTION_EVENTS = ['legendselectchanged', 'legendselected', 'legendunselected', 'datazoom', 'datarangeselected', 'timelinechanged', 'timelineplaychanged', 'restore', 'dataviewchanged', 'magictypechanged', 'geoselectchanged', 'geoselected', 'geounselected', 'pieselectchanged', 'pieselected', 'pieunselected', 'mapselectchanged', 'mapselected', 'mapunselected', 'axisareaselected', 'focusnodeadjacency', 'unfocusnodeadjacency', 'brush', 'brushselected'];

var MOUSE_EVENTS = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousedown', 'mouseup', 'globalout'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    options: Object,
    theme: [String, Object],
    initOptions: Object,
    group: String,
    autoResize: Boolean,
    watchShallow: Boolean
  },
  data: function data() {
    return {
      chart: null
    };
  },

  computed: {
    // Only recalculated when accessed from JavaScript.
    // Won't update DOM on value change because getters
    // don't depend on reactive values
    width: {
      cache: false,
      get: function get() {
        return this.delegateGet('width', 'getWidth');
      }
    },
    height: {
      cache: false,
      get: function get() {
        return this.delegateGet('height', 'getHeight');
      }
    },
    isDisposed: {
      cache: false,
      get: function get() {
        return !!this.delegateGet('isDisposed', 'isDisposed');
      }
    },
    computedOptions: {
      cache: false,
      get: function get() {
        return this.delegateGet('computedOptions', 'getOption');
      }
    }
  },
  watch: {
    group: function group(_group) {
      this.chart.group = _group;
    }
  },
  methods: {
    // provide a explicit merge option method
    mergeOptions: function mergeOptions(options, notMerge, lazyUpdate) {
      this.delegateMethod('setOption', options, notMerge, lazyUpdate);
    },

    // just delegates ECharts methods to Vue component
    // use explicit params to reduce transpiled size for now
    resize: function resize(options) {
      this.delegateMethod('resize', options);
    },
    dispatchAction: function dispatchAction(payload) {
      this.delegateMethod('dispatchAction', payload);
    },
    convertToPixel: function convertToPixel(finder, value) {
      return this.delegateMethod('convertToPixel', finder, value);
    },
    convertFromPixel: function convertFromPixel(finder, value) {
      return this.delegateMethod('convertFromPixel', finder, value);
    },
    containPixel: function containPixel(finder, value) {
      return this.delegateMethod('containPixel', finder, value);
    },
    showLoading: function showLoading(type, options) {
      this.delegateMethod('showLoading', type, options);
    },
    hideLoading: function hideLoading() {
      this.delegateMethod('hideLoading');
    },
    getDataURL: function getDataURL(options) {
      return this.delegateMethod('getDataURL', options);
    },
    getConnectedDataURL: function getConnectedDataURL(options) {
      return this.delegateMethod('getConnectedDataURL', options);
    },
    clear: function clear() {
      this.delegateMethod('clear');
    },
    dispose: function dispose() {
      this.delegateMethod('dispose');
    },
    delegateMethod: function delegateMethod(name) {
      var _chart;

      if (!this.chart) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].util.warn('Cannot call [' + name + '] before the chart is initialized. Set prop [options] first.', this);
        return;
      }

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_chart = this.chart)[name].apply(_chart, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args));
    },
    delegateGet: function delegateGet(name, method) {
      if (!this.chart) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].util.warn('Cannot get [' + name + '] before the chart is initialized. Set prop [options] first.', this);
      }
      return this.chart[method]();
    },
    init: function init() {
      var _this = this;

      if (this.chart) {
        return;
      }

      var chart = __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.init(this.$el, this.theme, this.initOptions);

      if (this.group) {
        chart.group = this.group;
      }

      chart.setOption(this.options, true);

      // expose ECharts events as custom events
      ACTION_EVENTS.forEach(function (event) {
        chart.on(event, function (params) {
          _this.$emit(event, params);
        });
      });
      MOUSE_EVENTS.forEach(function (event) {
        chart.on(event, function (params) {
          _this.$emit(event, params);

          // for backward compatibility, may remove in the future
          _this.$emit('chart' + event, params);
        });
      });

      if (this.autoResize) {
        this.__resizeHanlder = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(function () {
          chart.resize();
        }, 100, { leading: true });
        window.addEventListener('resize', this.__resizeHanlder);
      }

      this.chart = chart;
    },
    destroy: function destroy() {
      if (this.autoResize) {
        window.removeEventListener('resize', this.__resizeHanlder);
      }
      this.dispose();
      this.chart = null;
    },
    refresh: function refresh() {
      this.destroy();
      this.init();
    }
  },
  created: function created() {
    var _this2 = this;

    this.$watch('options', function (options) {
      if (!_this2.chart && options) {
        _this2.init();
      } else {
        _this2.chart.setOption(_this2.options, true);
      }
    }, { deep: !this.watchShallow });

    var watched = ['theme', 'initOptions', 'autoResize', 'watchShallow'];
    watched.forEach(function (prop) {
      _this2.$watch(prop, function () {
        _this2.refresh();
      }, { deep: true });
    });
  },
  mounted: function mounted() {
    // auto init if `options` is already provided
    if (this.options) {
      this.init();
    }
  },
  activated: function activated() {
    if (this.autoResize) {
      this.chart && this.chart.resize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.destroy();
  },
  connect: function connect(group) {
    if (typeof group !== 'string') {
      group = group.map(function (chart) {
        return chart.chart;
      });
    }
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.connect(group);
  },
  disconnect: function disconnect(group) {
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.disConnect(group);
  },
  registerMap: function registerMap() {
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.registerMap.apply(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a, arguments);
  },
  registerTheme: function registerTheme() {
    __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.registerTheme.apply(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a, arguments);
  }
});

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppFooter__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BrandLogo__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BrandLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_BrandLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SummonerSearch__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SummonerSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SummonerSearch__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  components: {
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components_AppFooter___default.a,
    BrandLogo: __WEBPACK_IMPORTED_MODULE_2__components_BrandLogo___default.a,
    SummonerSearch: __WEBPACK_IMPORTED_MODULE_3__components_SummonerSearch___default.a
  },

  computed: {
    darkThemeEnabled: function darkThemeEnabled() {
      return __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */].darkThemeEnabled;
    }
  }
});

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ToggleDarkTheme__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ToggleDarkTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ToggleDarkTheme__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ToggleDarkTheme: __WEBPACK_IMPORTED_MODULE_0__ToggleDarkTheme___default.a
  },

  computed: {
    currentYear: function currentYear() {
      return new Date().getFullYear();
    }
  }
});

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    light: {
      type: Boolean
    },
    large: {
      type: Boolean
    }
  }
});

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(85);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    summoner: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      updating: false,
      now: Date.now(),
      error: false,
      errorMessage: ''
    };
  },

  computed: {
    region: function region() {
      return this.$route.params.region;
    },
    summonerName: function summonerName() {
      return this.$route.params.name;
    },
    lastUpdateAttempt: function lastUpdateAttempt() {
      if (!this.summoner.league_update_attempted_at) {
        return 'never';
      }

      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.summoner.league_update_attempted_at).from(this.now);
    },
    justUpdated: function justUpdated() {
      if (!this.summoner.league_update_attempted_at) {
        return false;
      }

      var fiveMinutesAgo = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.now).subtract(5, 'minutes');

      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.summoner.league_update_attempted_at).isAfter(fiveMinutesAgo);
    }
  },

  mounted: function mounted() {
    setInterval(this.updateCurrentTime, 1000);
  },
  destroyed: function destroyed() {
    clearInterval(this.updateCurrentTime);
  },


  methods: {
    updateCurrentTime: function updateCurrentTime() {
      this.now = Date.now();
    },
    checkForGames: function checkForGames() {
      var _this = this;

      this.updating = true;
      this.error = false;

      __WEBPACK_IMPORTED_MODULE_1__api__["c" /* forceLeagueUpdate */](this.summonerName, this.region).then(function () {
        _this.updating = false;
      }).catch(function (_ref) {
        var response = _ref.response;

        _this.error = true;
        _this.updating = false;

        if (response.status === 422) {
          var timeToWaitInMinutes = __WEBPACK_IMPORTED_MODULE_0_moment___default()(response.data.data.league_update_attempted_at).add(5, 'minutes').diff(__WEBPACK_IMPORTED_MODULE_0_moment___default()(), 'minutes');

          _this.errorMessage = 'Just updated recently, wait ' + timeToWaitInMinutes + ' minutes';
        } else {
          _this.errorMessage = 'Whoops an error occured, try again';
        }
      });
    }
  }
});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_echarts_components_ECharts__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_echarts_components_ECharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_echarts_components_ECharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_bar__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_grid__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_tooltip__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__state__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    differences: {
      type: Array,
      required: true
    }
  },

  components: {
    ECharts: __WEBPACK_IMPORTED_MODULE_1_vue_echarts_components_ECharts___default.a
  },

  computed: {
    orderedDifferences: function orderedDifferences() {
      return this.differences.reverse();
    },
    chartOptions: function chartOptions() {
      return {
        grid: {
          left: 0,
          right: 0,
          top: 15,
          bottom: 15,
          width: '100%',
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          position: 'bottom',
          formatter: function formatter(_ref) {
            var name = _ref.name,
                value = _ref.value;

            var day = void 0;
            if (__WEBPACK_IMPORTED_MODULE_0_moment___default()().isSame(__WEBPACK_IMPORTED_MODULE_0_moment___default()(name), 'd')) {
              day = 'today';
            } else {
              day = __WEBPACK_IMPORTED_MODULE_0_moment___default()(name).endOf('day').fromNow();
            }
            return '\n            <div style="text-align:center;">\n              ' + day + '\n            <div>\n            ';
          }
        },
        xAxis: [{
          show: true,
          type: 'category',
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: __WEBPACK_IMPORTED_MODULE_6__state__["a" /* default */].darkThemeEnabled ? 'rgba(0,0,0,.23)' : '#F1F4F7'
            }
          },
          data: this.orderedDifferences.map(function (difference) {
            return difference.day;
          })
        }],
        yAxis: [{
          show: false,
          axisLabel: {
            inside: true
          }
        }],
        label: {
          normal: {
            formatter: function formatter(_ref2) {
              var data = _ref2.data;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utilities__["a" /* formatLeaguePositionChange */])(data.value);
            }
          },
          emphasis: {
            formatter: function formatter(_ref3) {
              var data = _ref3.data;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utilities__["a" /* formatLeaguePositionChange */])(data.value);
            }
          }
        },
        series: [{
          type: 'bar',
          itemStyle: {
            normal: {
              color: function color(params) {
                if (params.data.value >= 0) {
                  return '#00A7FF';
                }

                return '#FF4678';
              }
            }
          },
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          barWidth: '40%',
          data: this.orderedDifferences.map(function (difference) {
            return difference.difference;
          }).map(function (datapoint) {
            return { value: datapoint, label: { normal: { position: datapoint >= 0 ? 'top' : 'bottom' } } };
          })
        }]
      };
    }
  }
});

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_echarts_components_ECharts__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_echarts_components_ECharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_echarts_components_ECharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_line__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_grid__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_tooltip__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_visualMap__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_visualMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_visualMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_dataZoom__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_dataZoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_dataZoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__state__ = __webpack_require__(31);

//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    history: {
      type: Array,
      required: true
    }
  },

  components: {
    ECharts: __WEBPACK_IMPORTED_MODULE_2_vue_echarts_components_ECharts___default.a
  },

  computed: {
    orderedHistory: function orderedHistory() {
      return this.history;
    },
    chartOptions: function chartOptions() {
      return {
        grid: {
          left: 5,
          right: 7,
          top: 15,
          bottom: 45,
          // width: '100%',
          containLabel: true
        },
        dataZoom: [{
          dataBackground: {
            lineStyle: {
              color: __WEBPACK_IMPORTED_MODULE_8__state__["a" /* default */].darkThemeEnabled ? 'rgba(0,0,0,.23)' : '#F1F4F7',
              width: 1
            },
            areaStyle: {
              color: __WEBPACK_IMPORTED_MODULE_8__state__["a" /* default */].darkThemeEnabled ? 'rgba(0,0,0,.43)' : '#F1F4F7',
              opacity: 1
            }
          },
          fillerColor: 'rgba(0, 167, 255, .4)',
          borderColor: 'none',
          handleStyle: {
            color: 'rgba(0, 167, 255, 1)'
          },
          labelFormatter: function labelFormatter(value, valueStr) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(valueStr).format('LLL');
          }
        }],
        tooltip: {
          trigger: 'axis',
          position: 'bottom',
          formatter: function formatter(params) {
            var _params$0$data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(params[0]['data'], 4),
                date = _params$0$data[0],
                rank = _params$0$data[2],
                leaguePoints = _params$0$data[3];

            return '\n            <div style="text-align:left;">\n              ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('LL') + '<br>\n              ' + rank + ' - ' + leaguePoints + ' LP\n            <div>\n            ';
          }
        },
        xAxis: {
          show: true,
          type: 'category',
          silent: true,
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            formatter: function formatter(date) {
              return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('LL');
            },

            textStyle: {
              color: __WEBPACK_IMPORTED_MODULE_8__state__["a" /* default */].darkThemeEnabled ? '#F5F7F7' : '#444546',
              fontFamily: "'Avenir', Helvetica, Arial, sans-serif"
            }
          },
          axisPointer: {
            lineStyle: {
              width: 1,
              type: 'dashed',
              color: '#00A7FF',
              opacity: 0.5
            }
          },
          axisLine: {
            lineStyle: {
              color: __WEBPACK_IMPORTED_MODULE_8__state__["a" /* default */].darkThemeEnabled ? 'rgba(0,0,0,.23)' : '#F1F4F7'
            }
          },
          data: this.orderedHistory.map(function (leaguePosition) {
            return leaguePosition.date;
          })
        },
        yAxis: {
          type: 'value',
          show: false,
          min: 'dataMin',
          axisLabel: {
            show: false,
            inside: true
          }
        },
        visualMap: {
          show: false,
          type: 'piecewise',
          dimension: 1,
          pieces: [{ gt: 500, lte: 1000, label: 'BRONZE', color: '#7E6E53' }, { gt: 1000, lte: 1500, label: 'SILVER', color: '#8698A3' }, { gt: 1500, lte: 2000, label: 'GOLD', color: '#FFBA00' }, { gt: 2000, lte: 2500, label: 'PLATINUM', color: '#3AC1B7' }, { gt: 2500, lte: 3000, label: 'DIAMOND', color: '#3D93DD' }, { gt: 3000, label: 'MASTER / CHALLENGER', color: '#FFBA00' }]
        },
        series: [{
          showSymbol: false,
          areaStyle: {
            normal: {
              opacity: 0.1
            }
          },
          type: 'line',
          sampling: 'average',
          smooth: false,
          lineStyle: {
            normal: {
              width: 3,
              opacity: 1
            }
          },
          data: this.orderedHistory.map(function (leaguePosition) {
            return [leaguePosition.date, leaguePosition.score, leaguePosition.rank, leaguePosition.league_points];
          })
        }]
      };
    }
  }
});

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__(86);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    leaguePosition: {
      type: Object,
      required: true
    }
  },

  computed: {
    outcome: function outcome() {
      return this.leaguePosition.is_win === true ? 'WIN' : 'LOSS';
    },
    outcomeClass: function outcomeClass() {
      return this.leaguePosition.is_win === true ? 'game--win' : 'game--loss';
    },
    change: function change() {
      if (this.leaguePosition.is_initial) {
        return;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* formatLeaguePositionChange */])(this.leaguePosition.change);
    },
    rank: function rank() {
      var tier = this.leaguePosition.tier;
      var division = this.leaguePosition.division;

      return ['MASTER', 'CHALLENGER'].includes(tier) ? tier : tier + ' ' + division;
    },
    trackedAt: function trackedAt() {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.leaguePosition.created_at).fromNow();
    }
  }
});

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    paginator: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean
    }
  }
});

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},

  props: {},

  data: function data() {
    return {};
  },


  computed: {},

  methods: {}
});

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_QueueSwitcher__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_QueueSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_QueueSwitcher__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var tierIcons = __webpack_require__(449);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    QueueSwitcher: __WEBPACK_IMPORTED_MODULE_0__components_QueueSwitcher___default.a
  },

  props: {
    summoner: {
      type: Object,
      required: true
    }
  },

  computed: {
    tierIcon: function tierIcon() {
      var tier = this.summoner.tier ? this.summoner.tier.toLowerCase() : 'unranked';

      return tierIcons('./' + tier + '.png');
    }
  }
});

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_blu_src_components_dropdown__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_blu_src_components_menu__ = __webpack_require__(194);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    center: {
      type: Boolean
    },
    large: {
      type: Boolean
    }
  },
  computed: {
    regions: function regions() {
      return __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */].regions;
    },
    selectedRegion: function selectedRegion() {
      return __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */].selectedRegion;
    }
  },
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_1_vue_blu_src_components_dropdown__["a" /* default */],
    Menus: __WEBPACK_IMPORTED_MODULE_2_vue_blu_src_components_menu__["a" /* Menus */],
    VMenuItem: __WEBPACK_IMPORTED_MODULE_2_vue_blu_src_components_menu__["b" /* MenuItem */]
  },
  methods: {
    setRegion: function setRegion(region) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */].selectedRegion = region;

      setTimeout(function () {
        _this.$refs.dropdown.hidePopper();
      }, 50);
    },
    searchSummoner: function searchSummoner(e) {
      var region = this.selectedRegion.code;
      var name = e.target.value;

      this.$router.push({
        name: 'Summoner',
        params: {
          region: region,
          name: name
        }
      });
    },
    doNothing: function doNothing() {}
  }
});

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__(31);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    enabled: function enabled() {
      return __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */].darkThemeEnabled;
    },
    buttonText: function buttonText() {
      if (this.enabled) {
        return 'Deactivate Dark Theme';
      }

      return 'Activate Dark Theme';
    }
  },

  methods: {
    toggleDarkTheme: function toggleDarkTheme() {
      __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */].darkThemeEnabled = !__WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */].darkThemeEnabled;
      localStorage.setItem('dark-theme-enabled', __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */].darkThemeEnabled);
    }
  }
});

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BrandLogo__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BrandLogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_BrandLogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SummonerSearch__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SummonerSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_SummonerSearch__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BrandLogo: __WEBPACK_IMPORTED_MODULE_0__components_BrandLogo___default.a,
    SummonerSearch: __WEBPACK_IMPORTED_MODULE_1__components_SummonerSearch___default.a
  }
});

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_socket_io_client__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_laravel_echo__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SummonerSearch__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SummonerSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_SummonerSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ForceLeagueUpdate__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ForceLeagueUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ForceLeagueUpdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SummonerBanner__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SummonerBanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_SummonerBanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LeaguePosition__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LeaguePosition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_LeaguePosition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_GainLossGraph__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_GainLossGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_GainLossGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Paginator__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Paginator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Paginator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_LeaguePointsHistoryGraph__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_LeaguePointsHistoryGraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_LeaguePointsHistoryGraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Spinner__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















window.io = __WEBPACK_IMPORTED_MODULE_1_socket_io_client___default.a;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      paginatorLoading: false,
      summoner: {},
      leaguePointsHistory: [],
      error: false,
      errorDetails: {}
    };
  },

  computed: {
    leaguePositions: function leaguePositions() {
      return this.summoner.league_positions.data;
    },
    leaguePositionsPaginator: function leaguePositionsPaginator() {
      return this.summoner.league_positions.meta.pagination;
    },
    dailyDifferences: function dailyDifferences() {
      return this.summoner.daily_differences.data;
    },
    hasLeaguePositions: function hasLeaguePositions() {
      return this.leaguePositions.length >= 1;
    },
    region: function region() {
      return this.$route.params.region;
    },
    summonerName: function summonerName() {
      return this.$route.params.name;
    },
    queue: function queue() {
      if (this.$route.meta.queue === 'flex') {
        return 'RANKED_FLEX_SR';
      }

      return 'RANKED_SOLO_5x5';
    },
    queueName: function queueName() {
      if (this.$route.meta.queue === 'flex') {
        return 'flex';
      }

      return 'solo';
    }
  },

  components: {
    SummonerSearch: __WEBPACK_IMPORTED_MODULE_4__components_SummonerSearch___default.a,
    ForceLeagueUpdate: __WEBPACK_IMPORTED_MODULE_5__components_ForceLeagueUpdate___default.a,
    SummonerBanner: __WEBPACK_IMPORTED_MODULE_6__components_SummonerBanner___default.a,
    LeaguePosition: __WEBPACK_IMPORTED_MODULE_7__components_LeaguePosition___default.a,
    GainLossGraph: __WEBPACK_IMPORTED_MODULE_8__components_GainLossGraph___default.a,
    Paginator: __WEBPACK_IMPORTED_MODULE_9__components_Paginator___default.a,
    LeaguePointsHistoryGraph: __WEBPACK_IMPORTED_MODULE_10__components_LeaguePointsHistoryGraph___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_11__components_Spinner___default.a
  },

  created: function created() {
    window.Echo = new __WEBPACK_IMPORTED_MODULE_2_laravel_echo__["a" /* default */]({
      broadcaster: 'socket.io',
      host: "https://ws.leaguepoints.lol"
    });
  },
  mounted: function mounted() {
    this.loadSummoner();
  },


  watch: {
    '$route': function $route() {
      window.Echo.leave('leaguepoints_database_summoner:' + this.summoner.summoner_id);

      this.loadSummoner();
    }
  },

  methods: {
    loadSummoner: function loadSummoner() {
      var _this = this;

      this.loading = true;
      this.leaguePointsHistory = [];
      this.error = false;
      this.errorDetails = {};

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* summonerByName */](this.summonerName, this.region, ['league_positions', 'daily_differences'], this.queue).then(function (_ref) {
        var summoner = _ref.data.data;

        _this.summoner = summoner;
        _this.loading = false;
        _this.loadLeaguePointsHistory();

        _this.listenForUpdates(summoner.summoner_id);
      }).catch(function (_ref2) {
        var response = _ref2.response;

        _this.error = true;
        _this.errorDetails.response = response.data.data;
        _this.errorDetails.status = response.status;
        _this.loading = false;
      });
    },
    listenForUpdates: function listenForUpdates(summonerId) {
      var _this2 = this;

      console.log('listening for summoner ' + summonerId);
      window.Echo.channel('leaguepoints_database_summoner:' + summonerId).listen('LeaguePositionUpdated', this.updateSummoner).listen('LeaguePositionUpdateAttempted', function (b, e) {
        _this2.summoner.league_update_attempted_at = __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'seconds').toISOString();
        _this2.summoner.in_update_queue = false;
      }).listen('QueuedForLeaguePositionUpdate', function (b, e) {
        _this2.summoner.in_update_queue = true;
      });
    },
    updateSummoner: function updateSummoner() {
      var _this3 = this;

      console.log('Starting summoner update...');
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* summonerByName */](this.summonerName, this.region, ['league_positions', 'daily_differences'], this.queue).then(function (_ref3) {
        var summoner = _ref3.data.data;

        _this3.summoner = summoner;
        _this3.loadLeaguePointsHistory();
      });
    },
    loadMoreItems: function loadMoreItems(nextPage) {
      var _this4 = this;

      this.paginatorLoading = true;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* summonerByName */](this.summonerName, this.region, ['league_positions'], this.queue, nextPage).then(function (_ref4) {
        var summoner = _ref4.data.data;

        _this4.summoner.league_positions.data = _this4.summoner.league_positions.data.concat(summoner.league_positions.data);
        _this4.summoner.league_positions.meta = summoner.league_positions.meta;
        _this4.paginatorLoading = false;
      });
    },
    loadLeaguePointsHistory: function loadLeaguePointsHistory() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_3__api__["b" /* leaguePointsHistory */](this.summonerName, this.region, this.queue).then(function (_ref5) {
        var leaguePositions = _ref5.data.data;

        _this5.leaguePointsHistory = leaguePositions;
      });
    }
  }
});

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_save_state__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_save_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_save_state__);



var regions = [{ name: 'Europe West', code: 'euw' }, { name: 'North America', code: 'na' }, { name: 'Europe Nordic & East', code: 'eune' }, { name: 'Oceania', code: 'oce' }, { name: 'Latin America North', code: 'lan' }, { name: 'Latin America South', code: 'las' }, { name: 'Korea', code: 'kr' }, { name: 'Japan', code: 'jp' }, { name: 'Brazil', code: 'br' }, { name: 'Russia', code: 'ru' }, { name: 'Turkey', code: 'tr' }];

var darkThemeEnabled = JSON.parse(localStorage.getItem('dark-theme-enabled')) === true;

var state = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_save_state___default.a],

  data: {
    darkThemeEnabled: darkThemeEnabled,
    regions: regions,
    selectedRegion: regions[0]
  },

  methods: {
    getSaveStateConfig: function getSaveStateConfig() {
      return {
        'cacheKey': 'state',
        'saveProperties': ['selectedRegion']
      };
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 335:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 342:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 356;

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/diamond.eb6d27e.png";

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gold.95dc794.png";

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/grandmaster.5fd12b9.png";

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iron.37ae9f9.png";

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/master.a0c3803.png";

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/platinum.f951348.png";

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/silver.516f646.png";

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/unranked.6cc81a5.png";

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(408),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c17e4b26",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(343)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(406),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-753a8534",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(332)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(392),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03b769fd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(396),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-400fca2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(409),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c2a84812",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(333)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(394),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e014ce2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(334)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(395),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-255d4ee3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(336)
}
var Component = __webpack_require__(5)(
  /* script */
  null,
  /* template */
  __webpack_require__(397),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4104e12a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(340)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(402),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5318dc99",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(405),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-729e13e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(410),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d13aeb6a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(401),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(400),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(404),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(393),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 392:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('e-charts', {
    attrs: {
      "options": _vm.chartOptions,
      "auto-resize": ""
    }
  }), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-title"
  }, [_c('span', [_vm._v("DAILY LP GAIN / LOSS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-range"
  }, [_c('div', [_vm._v("7 played days ago")]), _vm._v(" "), _c('div', [_vm._v("today")])])
}]}

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.label) ? _c('p', {
    staticClass: "menu-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "menu-list",
    class: _vm.type
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.paginator.current_page < _vm.paginator.total_pages) ? _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.$emit('loadMoreItems', _vm.paginator.current_page + 1)
      }
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]) : _c('span', [_vm._v("more")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 395:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "queue-navigation"
  }, [_c('div', {}, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "is-small button is-darkmode-dark",
    attrs: {
      "to": {
        name: 'Summoner'
      },
      "exact-active-class": "is-primary is-selected"
    }
  }, [_vm._v("SOLO")])], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "is-small button is-darkmode-dark",
    attrs: {
      "to": {
        name: 'SummonerFlex'
      },
      "exact-active-class": "is-primary is-selected"
    }
  }, [_vm._v("FLEX")])], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('e-charts', {
    attrs: {
      "options": _vm.chartOptions,
      "auto-resize": ""
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-title"
  }, [_c('span', [_vm._v("LP HISTORY")])])
}]}

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  })
},staticRenderFns: []}

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "echarts"
  })
},staticRenderFns: []}

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'is-dark': _vm.darkThemeEnabled
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "navbar__container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('header', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('brand-logo', {
    attrs: {
      "light": ""
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    attrs: {
      "id": "main-nav"
    }
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('summoner-search')], 1)])])])])]), _vm._v(" "), _c('main', {
    staticClass: "section"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-burger",
    attrs: {
      "data-target": "main-nav"
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
}]}

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "dropdown"
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    ref: "popper",
    staticClass: "popover popper-dropdown",
    style: (_vm.popperStyle)
  }, [_c('div', {
    staticClass: "popover-content dropdown-content"
  }, [_vm._t("content", [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.content)
    }
  })])], 2)])])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('spinner') : _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.error) ? _c('div', {
    staticClass: "container"
  }, [_c('force-league-update', {
    attrs: {
      "summoner": _vm.summoner
    }
  }), _vm._v(" "), _c('summoner-banner', {
    attrs: {
      "summoner": _vm.summoner
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-12-tablet is-5-desktop"
  }, [(_vm.dailyDifferences.length) ? _c('gain-loss-graph', {
    attrs: {
      "differences": _vm.dailyDifferences
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-12-tablet is-7-desktop"
  }, [(!_vm.hasLeaguePositions) ? _c('div', {
    staticClass: "box box--highlight",
    staticStyle: {
      "padding-top": "2rem",
      "padding-bottom": "2rem"
    }
  }, [_c('h2', {
    staticClass: "title is-4 is-primary",
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v("No tracked " + _vm._s(_vm.queueName) + " queue games")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n              The summoner just got added to the system or hasn't played any ranked games yet."), _c('br')]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Come back later!")])])])]) : _vm._e(), _vm._v(" "), (_vm.hasLeaguePositions) ? _c('div', {
    staticClass: "league-positions"
  }, [_vm._l((_vm.leaguePositions), function(leaguePosition) {
    return _c('league-position', {
      key: leaguePosition.id,
      attrs: {
        "league-position": leaguePosition
      }
    })
  }), _vm._v(" "), _c('paginator', {
    attrs: {
      "paginator": _vm.leaguePositionsPaginator,
      "loading": _vm.paginatorLoading
    },
    on: {
      "loadMoreItems": _vm.loadMoreItems
    }
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-12"
  }, [(_vm.leaguePointsHistory.length > 1) ? _c('league-points-history-graph', {
    attrs: {
      "history": _vm.leaguePointsHistory
    }
  }) : _vm._e()], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "container"
  }, [(_vm.errorDetails.status === 404) ? _c('div', {
    staticClass: "box box--error"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-narrow"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(145),
      "alt": "error image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "title is-5 is-danger"
  }, [_vm._v("Could not find the summoner!")]), _vm._v(" "), _c('p', [_vm._v("Didn't find the summoner "), _c('strong', [_vm._v(_vm._s(_vm.errorDetails.response.name) + " @ " + _vm._s(_vm.errorDetails.response.region.name))]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Please check the spelling and the region.")]), _vm._v(" "), _c('summoner-search', {
    staticStyle: {
      "margin-top": "1.5rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content is-small",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('p', [_vm._v("The search is "), _c('strong', [_vm._v("not")]), _vm._v(" case sensitive.")])])], 1)])]) : _c('div', {
    staticClass: "box box--error"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-narrow"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(144),
      "alt": "error image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "title is-5 is-danger"
  }, [_vm._v("The server responded with an error!")]), _vm._v(" "), _c('p', [_vm._v("Please try it again.")]), _vm._v(" "), _c('summoner-search', {
    staticStyle: {
      "margin-top": "1.5rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content is-small",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('p', [_vm._v("The search is "), _c('strong', [_vm._v("not")]), _vm._v(" case sensitive.")])])], 1)])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box--highlight"
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-narrow is-flex"
  }, [_c('div', {
    staticClass: "tier is-flex"
  }, [_c('div', {
    staticClass: "tier__icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.tierIcon,
      "alt": ((_vm.summoner.rank) + " icon")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-flex"
  }, [_c('div', {
    staticClass: "summoner is-flex"
  }, [_c('div', {
    staticClass: "summoner__name"
  }, [_vm._v(_vm._s(_vm.summoner.name))]), _vm._v(" "), (_vm.summoner.rank) ? _c('div', {
    staticClass: "summoner__rank"
  }, [_vm._v(_vm._s(_vm.summoner.rank) + ", " + _vm._s(_vm.summoner.league_points) + " LP")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow is-flex"
  }, [_c('div', {
    staticClass: "summoner-score is-flex"
  }, [_c('div', {
    staticClass: "summoner-score__value"
  }, [_vm._v(_vm._s(_vm.summoner.score))]), _vm._v(" "), _c('div', {
    staticClass: "summoner-score__subtitle"
  }, [_vm._v("Leaguepoints Score")]), _vm._v(" "), _c('QueueSwitcher')], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field has-addons summoner-search",
    class: {
      'summoner-search--center': _vm.center,
      'summoner-search--large': _vm.large,
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('dropdown', {
    ref: "dropdown"
  }, [_c('a', {
    staticClass: "button is-primary summoner-search__region-switcher"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "9.293 12.95 10 13.657 15.657 8 14.243 6.586 10 10.828 5.757 6.586 4.343 8"
    }
  })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.selectedRegion.code.toUpperCase()))])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('menus', _vm._l((_vm.regions), function(region) {
    return _c('v-menu-item', {
      key: region.code,
      attrs: {
        "click": _vm.doNothing,
        "isActive": _vm.selectedRegion.code === region.code
      },
      nativeOn: {
        "click": function($event) {
          return _vm.setRegion(region)
        }
      }
    }, [_vm._v(_vm._s(region.code.toUpperCase()))])
  }), 1)], 1)])], 1), _vm._v(" "), _c('p', {
    staticClass: "control summoner-search__search-container"
  }, [_c('input', {
    staticClass: "input summoner-search__search-field",
    attrs: {
      "type": "search",
      "placeholder": "Find a summoner"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchSummoner($event)
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      'is-active': _vm.isActive
    }
  }, [(!_vm.hasChildren) ? _c('span', [(!_vm.click) ? _c('router-link', {
    attrs: {
      "to": _vm.to,
      "exact": ""
    }
  }, [(_vm.icon) ? _c('i', {
    staticClass: "fa",
    class: [("fa-" + _vm.icon)]
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.click) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.click
    }
  }, [(_vm.icon) ? _c('i', {
    staticClass: "fa",
    class: [("fa-" + _vm.icon)]
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.hasChildren) ? _c('span', [_c('a', {
    staticClass: "has-children",
    class: {
      'is-active': _vm.isActive, 'is-open': _vm.isOpen,
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.toggle
    }
  }, [(_vm.icon) ? _c('i', {
    staticClass: "fa",
    class: [("fa-" + _vm.icon)]
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('span', {
    staticClass: "nav-right"
  }, [_c('i', {
    staticClass: "fa",
    class: [_vm.arrowClass]
  })])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }]
  }, [_vm._t("sub")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 405:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button is-primary is-inverted is-outlined is-small",
    on: {
      "click": _vm.toggleDarkTheme
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])
},staticRenderFns: []}

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level is-mobile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [(!_vm.summoner.in_update_queue) ? _c('p', {
    staticClass: "level-item"
  }, [_vm._v("\n      Looked for new games " + _vm._s(_vm.lastUpdateAttempt) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.summoner.in_update_queue) ? _c('p', {
    staticClass: "level-item"
  }, [_vm._v("\n      In update queue, this can take a few minutes\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button is-primary is-small",
    class: {
      'is-loading': _vm.updating || _vm.summoner.in_update_queue, 'is-danger': _vm.error
    },
    attrs: {
      "disabled": _vm.justUpdated
    },
    on: {
      "click": _vm.checkForGames
    }
  }, [(!_vm.error) ? _c('span', [_vm._v("CHECK NOW")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('span', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level-left"
  }, [_c('p', {
    staticClass: "level-item"
  }, [_c('span', {
    staticClass: "connection-indicator"
  }), _vm._v(" LIVE\n    ")])])
}]}

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-logo",
    class: {
      'brand-logo--light': _vm.light,
      'brand-logo--large': _vm.large,
    }
  }, [_vm._v("LEAGUEPOINTS"), _c('span', [_vm._v(".")])])
},staticRenderFns: []}

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered is-small"
  }, [_c('p', [_c('toggle-dark-theme')], 1), _vm._v(" "), _c('p', [_vm._v("\n          © " + _vm._s(_vm.currentYear) + " leaguepoints.lol - Data provided by the official League of Legends API\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Leaguepoints. isn’t endorsed by Riot Games and doesn’t reflect the views or opinions of Riot Games or anyone officially involved in producing or managing League of Legends. League of Legends and Riot Games are trademarks or registered trademarks of Riot Games, Inc. League of Legends © Riot Games, Inc.\n        ")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box game",
    class: _vm.outcomeClass
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "game__value game__outcome"
  }, [_c('div', [_vm._v(_vm._s(_vm.outcome))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "game__value game__league-points"
  }, [_c('div', [_vm._v(_vm._s(_vm.leaguePosition.league_points) + " LP "), _c('span', {
    staticClass: "game__league-points-change"
  }, [_vm._v(_vm._s(_vm.change))])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "game__value game__rank"
  }, [_c('div', [_vm._v(_vm._s(_vm.rank))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "game__value game__date"
  }, [_c('div', [_vm._v(_vm._s(_vm.trackedAt))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "game__value game__score"
  }, [_c('div', {
    staticClass: "score__title"
  }, [_vm._v("Score")]), _vm._v(" "), _c('div', {
    staticClass: "score__value"
  }, [_vm._v(_vm._s(_vm.leaguePosition.score))])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('brand-logo', {
    attrs: {
      "large": ""
    }
  }), _vm._v(" "), _c('summoner-search', {
    attrs: {
      "center": "",
      "large": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "brand-lead"
  }, [_vm._v("\n        League of Legends League Points Tracker\n    ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./bronze.png": 144,
	"./challenger.png": 145,
	"./diamond.png": 369,
	"./gold.png": 370,
	"./grandmaster.png": 371,
	"./iron.png": 372,
	"./master.png": 373,
	"./platinum.png": 374,
	"./silver.png": 375,
	"./unranked.png": 376
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 449;

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(341)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(403),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = summonerByName;
/* harmony export (immutable) */ __webpack_exports__["b"] = leaguePointsHistory;
/* harmony export (immutable) */ __webpack_exports__["c"] = forceLeagueUpdate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var apiUrl = "https://api.leaguepoints.lol";

function summonerByName(name, region) {
  var includes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var queue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'RANKED_SOLO_5x5';
  var page = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

  var path = apiUrl + '/api/' + region + '/' + name;
  var params = {
    queue: queue,
    include: includes.join(','),
    page: page
  };

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(path, { params: params });
}

function leaguePointsHistory(name, region) {
  var queue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'RANKED_SOLO_5x5';
  var currentSeason = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var range = currentSeason ? 'current-season' : '';
  var path = apiUrl + '/api/' + region + '/' + name + '/league-points-history/' + range;

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(path, { params: { queue: queue } });
}

function forceLeagueUpdate(name, region) {
  var path = apiUrl + '/api/' + region + '/' + name + '/league-position-update';

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(path);
}

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLeaguePositionChange;
function formatLeaguePositionChange(value) {
  return value >= 0 ? "+" + value : value;
}

/***/ })

},[192]);


// WEBPACK FOOTER //
// static/js/app.753939285da0c0e40346.js